// MACHINE DRAFT — clinical and native-speaker review required.
export default {
  "pl": [
    "Pytania dotyczące przygotowania",
    "Wybierz kwestie, które chcesz omówić z personelem swojego szpitala.",
    "Wybierz to pytanie",
    "Zapisz wybrane pytania w Mojej opiece",
    "Wydrukuj wybrane pytania",
    "Już zapisano w Mojej opiece",
    "Wybrane pytania zostały zapisane w Mojej opiece na tym urządzeniu.",
    "Wybierz co najmniej jedno pytanie, aby je zapisać lub wydrukować.",
    "Pytania, które chcę zadać",
    "Oto wybrane przez Ciebie pytania dotyczące przygotowania. Możesz zapisać je w Mojej opiece lub wydrukować na wizytę.",
    "Otwórz Moją opiekę",
    "Wydrukowanie pytań nie powoduje wysłania ich do szpitala.",
    "Te pytania nie zastępują zaleceń Twojego szpitala. W kwestii leków, pozostawania na czczo i organizacji wypisu ze szpitala postępuj zgodnie z indywidualnymi zaleceniami personelu medycznego.",
    "Od kiedy przed operacją nie wolno mi jeść ani pić?",
    "Które z przyjmowanych na co dzień leków mam zażyć lub zmienić przed operacją?",
    "Dokąd mam się udać i o której godzinie przyjechać?",
    "Gdzie mam się zgłosić i o której godzinie przyjechać na przyjęcie do szpitala?",
    "Czy muszę samodzielnie zorganizować transport do szpitala, czy zapytać o uprawnienia do transportu dla pacjentów?",
    "Czy po operacji będę potrzebować kogoś, kto zabierze mnie do domu lub zostanie ze mną?",
    "Jakiej pomocy mogę potrzebować przy wypisie ze szpitala i z kim mam to omówić?",
    "Z kim mam się skontaktować, jeśli po powrocie do domu będę mieć jakieś obawy?"
  ],
  "pt": [
    "Perguntas sobre a minha preparação",
    "Selecione o que gostaria de conversar com a equipa do seu hospital.",
    "Selecionar esta pergunta",
    "Guardar as perguntas selecionadas em Os Meus Cuidados",
    "Imprimir as perguntas selecionadas",
    "Já guardada em Os Meus Cuidados",
    "As perguntas selecionadas foram guardadas em Os Meus Cuidados neste dispositivo.",
    "Selecione uma ou mais perguntas para guardar ou imprimir.",
    "Perguntas que quero fazer",
    "Estas são as perguntas de preparação que selecionou. Pode guardá-las em Os Meus Cuidados ou imprimi-las para a sua consulta.",
    "Abrir Os Meus Cuidados",
    "A impressão não envia as suas perguntas para o hospital.",
    "Estas perguntas não substituem as instruções do seu hospital. Quanto aos medicamentos, ao jejum e à organização da alta, siga as orientações individuais dadas pela sua equipa hospitalar.",
    "Quando devo deixar de comer e beber antes da minha operação?",
    "Quais dos meus medicamentos habituais devo tomar ou alterar antes da minha operação?",
    "Para onde devo ir e a que horas devo chegar?",
    "Onde me devo apresentar e a que horas devo chegar para o internamento?",
    "Preciso de organizar transporte para o hospital ou de perguntar se tenho direito ao transporte de doentes?",
    "Vou precisar de alguém que me leve para casa ou fique comigo depois da operação?",
    "De que ajuda poderei precisar quando tiver alta do hospital e com quem devo falar sobre isso?",
    "Quem devo contactar se tiver alguma preocupação depois de regressar a casa?"
  ],
  "ro": [
    "Întrebări despre pregătirea mea",
    "Selectați orice întrebare pe care ați dori să o discutați cu echipa spitalului dumneavoastră.",
    "Selectați această întrebare",
    "Salvați întrebările selectate în Îngrijirea mea",
    "Imprimați întrebările selectate",
    "Deja salvată în Îngrijirea mea",
    "Întrebările selectate au fost salvate în Îngrijirea mea pe acest dispozitiv.",
    "Selectați una sau mai multe întrebări pentru a le salva sau imprima.",
    "Întrebări pe care vreau să le adresez",
    "Acestea sunt întrebările despre pregătire pe care le-ați selectat. Le puteți salva în Îngrijirea mea sau le puteți imprima pentru programarea dumneavoastră.",
    "Deschideți Îngrijirea mea",
    "Imprimarea nu trimite întrebările dumneavoastră la spital.",
    "Aceste întrebări nu înlocuiesc instrucțiunile spitalului. Pentru medicamente, postul alimentar preoperator și organizarea externării, urmați recomandările individuale ale echipei care vă îngrijește la spital.",
    "Cu cât timp înainte de operație trebuie să încetez să mănânc și să beau?",
    "Pe care dintre medicamentele mele obișnuite trebuie să le iau sau să le modific înainte de operație?",
    "Unde trebuie să merg și la ce oră trebuie să ajung?",
    "Unde trebuie să mă prezint și când trebuie să ajung pentru internare?",
    "Trebuie să îmi organizez transportul către spital sau să întreb dacă sunt eligibil pentru transportul pacienților?",
    "Voi avea nevoie de cineva care să mă ducă acasă sau să rămână cu mine după operație?",
    "De ce ajutor aș putea avea nevoie la externare și cu cine ar trebui să discut?",
    "Pe cine ar trebui să contactez dacă am nelămuriri sau îngrijorări după ce mă întorc acasă?"
  ],
  "so": [
    "Su'aalaha ku saabsan diyaar-garowgayga",
    "Dooro su'aalaha aad rabto inaad kala hadasho kooxda daryeelka ee isbitaalkaaga.",
    "Dooro su'aashan",
    "Ku kaydi su'aalaha la doortay Daryeelkayga",
    "Daabac su'aalaha la doortay",
    "Hore ayaa loogu kaydiyay Daryeelkayga",
    "Su'aalaha la doortay waxaa lagu kaydiyay Daryeelkayga qalabkan.",
    "Dooro hal su'aal ama ka badan si aad u kaydiso ama u daabacdo.",
    "Su'aalaha aan rabo inaan waydiiyo",
    "Kuwani waa su'aalaha diyaar-garowga ee aad dooratay. Waxaad ku kaydin kartaa Daryeelkayga ama u daabici kartaa ballantaada.",
    "Fur Daryeelkayga",
    "Daabacaaddu uma dirto su'aalahaaga isbitaalka.",
    "Su'aalahani ma beddelayaan tilmaamaha isbitaalkaaga. Daawooyinka, ka soomidda cuntada iyo cabitaanka qalliinka ka hor, iyo qorshaha ka bixitaanka isbitaalka, raac talada gaarka ah ee kooxda daryeelka ee isbitaalkaaga.",
    "Goormaan joojinayaa cunista iyo cabitaanka ka hor qalliinkayga?",
    "Daawooyinkayga caadiga ah kuwee ayaan qaadanayaa ama beddelayaa ka hor qalliinkayga?",
    "Xaggee ayaan tegayaa, saacaddeese ayaan imaanayaa?",
    "Xaggee ayaan tagayaa, goormaanse imaanayaa si isbitaalka la ii seexiyo?",
    "Ma inaan diyaarsadaa gaadiidka isbitaalka mise inaan waydiiyaa haddii aan u qalmo gaadiidka bukaanka?",
    "Qalliinka ka dib ma u baahan doonaa qof guriga i geeya ama ila jooga?",
    "Caawimaad noocee ah ayaan u baahan karaa markaan isbitaalka ka baxo, yaanse kala hadlayaa?",
    "Yaan la xiriirayaa haddii aan walwal qabo ka dib marka aan guriga ku noqdo?"
  ]
};
